import gql from 'graphql-tag';

const GET_ALL_CATALOG_LOG_ITEMS = gql`
  query allCatalogLogItems {
    getCatalogLog {
      catalogSpecLabel,
      pricesheetLabel,
      generatedOn,
      generatedUrl,
    }
  }
`;

export default GET_ALL_CATALOG_LOG_ITEMS;
